"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _getSources = _interopRequireDefault(require("../source/getSources"));
var _stageFeaturedPresenter = _interopRequireDefault(require("./stageFeaturedPresenter"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function syncFeaturePresenter(presenterId) {
  return function (dispatch) {
    dispatch((0, _getSources["default"])());
    dispatch((0, _stageFeaturedPresenter["default"])(presenterId));
  };
}
var _default = exports["default"] = syncFeaturePresenter;